import { render, staticRenderFns } from "./Qualifications.vue?vue&type=template&id=9f2a3c1c"
import script from "./Qualifications.vue?vue&type=script&lang=js"
export * from "./Qualifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports